import React from 'react'

const Applications = () => {
  return (
    <div>Applications</div>
  )
}

export default Applications